import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppDispatch, AppThunk } from "../../../../../app/store";
import { EditRolesAndPermissions } from "../../../../../api/getEditRolesAndPermissions/types";
import { getEditRolesAndPermissions } from "../../../../../api/getEditRolesAndPermissions/getEditRolesAndPermissionsApi";

export interface EditRolesAndPermissionsState {
  rolesAndPermissions: EditRolesAndPermissions | null;
  loading: boolean;
  error: string | null;
}

const initialState: EditRolesAndPermissionsState = {
  rolesAndPermissions: null,
  loading: false,
  error: null,
};

const editRolesAndPermissionsSlice = createSlice({
  name: "editRolesAndPermissions",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setRolesAndPermissions: (
      state,
      action: PayloadAction<EditRolesAndPermissions>,
    ) => {
      state.rolesAndPermissions = action.payload;
    },
  },
});

export const {
  setLoading,
  setError,
  setRolesAndPermissions,
} = editRolesAndPermissionsSlice.actions;

// Thunk to fetch roles and features
export const fetchRolesAndPermissionsAction =
  (): AppThunk => async (dispatch: AppDispatch) => {
    dispatch(setLoading(true));
    try {
      const response = await getEditRolesAndPermissions();
      dispatch(setRolesAndPermissions(response.data));
    } catch (error) {
      dispatch(
        setError(
          error instanceof Error
            ? error.message
            : "Failed to fetch roles and features",
        ),
      );
    } finally {
      dispatch(setLoading(false));
    }
  };

export default editRolesAndPermissionsSlice.reducer;
